import { render, staticRenderFns } from "./DownloadPanel.vue?vue&type=template&id=1e58216f&scoped=true"
import script from "./DownloadPanel.vue?vue&type=script&lang=js"
export * from "./DownloadPanel.vue?vue&type=script&lang=js"
import style0 from "./DownloadPanel.vue?vue&type=style&index=0&id=1e58216f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e58216f",
  null
  
)

export default component.exports